import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import OptionChainFull from './option-chain-full';

const OptionChainFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <OptionChainFull {...props}/>
    </QueryClientProvider>
  );
};

export { OptionChainFullWidget }
